import { ApiService } from '~/lib/services/api-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useApiService = defineServiceComposable(
  'api',
  (nuxtApp) =>
    new ApiService(nuxtApp, {
      clientCookieService: useClientCookieService(),
      sentryService: useSentryService(),
      userLogoutService: useUserLogoutService(),
    }),
)
